export default {"src":"/_next/static/image/src/images/tag.22f32234cc8257e1b80391d0932966ac.svg","height":36,"width":35};